const cssVersionMap = require('../versions');

module.exports = {
  axios: {
    defaultTimeout: 60000,
  },
  loggingService: {
    enableRemoteLogging: false,
    enableConsole: true,
  },
  customerChat: {
    scriptUrl:
      'https://gco-c3-web-messenger-demo.us-west-2.test.gcotechp.expedia.com/c3-web-messenger.js',
  },
  errorViewCssUrl: `https://int.vap.expedia.com/c3cards/${cssVersionMap.errorView}/payment-{{brand}}.css`, // Duplicated in server config
};
